import { computed, defineComponent, PropType } from 'vue';
import { QuestionFilled, Setting } from '@element-plus/icons-vue';
import { storeToRefs } from 'pinia';
import { usePermissionsStore } from '@/store/permissions.store';
import { PS_MANAGEMENT_PERMISSIONS } from '@/models/app-internal/permissions.model';
import { GeoPaymentMethodItem } from '@/models/ps-management/ps-management.model';

const icons = {
  Setting,
  QuestionFilled,
};

export default defineComponent({
  name: 'GeoPaymentMethodToggle',
  props: {
    paymentMethodItem: {
      type: Object as PropType<GeoPaymentMethodItem>,
      required: true,
    },
    geoPaymentMethodProperty: {
      type: String,
      required: true,
    },
  },
  emits: ['updateGeoPaymentMethod'],
  setup(props, { emit }) {
    const { psManagementPermissions } = storeToRefs(usePermissionsStore());

    const isPartialUpdateGlobalPaymentMethodDisallowed = computed<boolean>(() =>
      !psManagementPermissions.value[PS_MANAGEMENT_PERMISSIONS.UPDATE_GEO_PAYMENT_METHOD_DEPOSIT_AND_WITHDRAW]);

    const updateGeoPaymentMethod = (): void => {
      emit('updateGeoPaymentMethod', props.paymentMethodItem, props.geoPaymentMethodProperty);
    };

    return {
      icons,
      updateGeoPaymentMethod,
      isPartialUpdateGlobalPaymentMethodDisallowed,
    };
  },
});
